/**
 * The Hydra Notes mark: three serpent necks rising from a common base,
 * drawn as round-capped strokes in the brand gradient. Works from 16px
 * favicons up to marketing sizes.
 */
export function LogoMark({ size = 24 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" fill="none" aria-hidden="true">
      <defs>
        <linearGradient id="hn-grad" x1="4" y1="28" x2="28" y2="4" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="hsl(152 66% 46%)" />
          <stop offset="1" stopColor="hsl(174 74% 44%)" />
        </linearGradient>
      </defs>
      {/* center neck */}
      <path d="M16 27 V13 Q16 7 16 6" stroke="url(#hn-grad)" strokeWidth="3.4" strokeLinecap="round" />
      {/* left neck */}
      <path d="M16 27 Q9 24 7.5 17 Q6.8 13.5 8.5 10.5" stroke="url(#hn-grad)" strokeWidth="3.4" strokeLinecap="round" />
      {/* right neck */}
      <path d="M16 27 Q23 24 24.5 17 Q25.2 13.5 23.5 10.5" stroke="url(#hn-grad)" strokeWidth="3.4" strokeLinecap="round" />
      {/* heads */}
      <circle cx="16" cy="5" r="2.1" fill="url(#hn-grad)" />
      <circle cx="8.2" cy="8.6" r="2.1" fill="url(#hn-grad)" />
      <circle cx="23.8" cy="8.6" r="2.1" fill="url(#hn-grad)" />
    </svg>
  );
}

export function Wordmark({ size = 14 }: { size?: number }) {
  return (
    <span
      style={{
        fontFamily: "var(--font-ui)",
        fontWeight: 650,
        fontSize: size,
        letterSpacing: "-0.01em",
        color: "var(--text-primary)",
        whiteSpace: "nowrap",
      }}
    >
      Hydra <span style={{ color: "var(--accent-text)" }}>Notes</span>
    </span>
  );
}
